import { AppDispatch, RootState } from 'src/store/store';
import { connect } from 'react-redux';
import ScanSourceForSort from './ScanSourceForSort';
import { setPageToRender, SortContainerPages } from 'src/store/common-slices/sortContainerSlice';
import { GetContainerDetailsInput } from 'src/models/GetContainerDetails';
import { fetchContainerDetails } from 'src/store/common-slices/getContainerSlice';
import { ContainerDetailsModel } from 'src/components/common/container-details/ContainerDetailsModel';
import { updateChildContainers } from 'src/store/common-slices/batchMoveContainersSlice';

const mapStateToProps = (state: RootState) => ({
    containerDetails: state.GetContainer.containerDetailsOutput?.container,
    childContainers: state.BatchMoveContainers.childContainers,
    warehouseId: state.Init.initData.gradingNodeDetails.id,
    associate: state.Init.initData.associateDetails.id,
    locale: state.Init.initData.associateDetails.locales[0],
    selectedSortType: state.SortContainer.selectedSortType
});

const mapDispatchToProps = (dispatch: AppDispatch) => ({
    setPageToRender: (pageToRender: SortContainerPages) => dispatch(setPageToRender(pageToRender)),
    fetchContainerDetails: (getContainerDetailsInput: GetContainerDetailsInput) => dispatch(fetchContainerDetails(getContainerDetailsInput)),
    updateChildContainers: (newContainer: ContainerDetailsModel) => dispatch(updateChildContainers(newContainer)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ScanSourceForSort);
